export const WidgetContainer = ({
  children,
  mode,
}: {
  mode: 'widget' | 'card';
  children: React.ReactNode;
}) => {
  return (
    <div
      className="tw-cds-bg-primary tw-cds-border-color-default tw-rounded-1.6 tw-border tw-border-solid tw-p-1.6"
      style={{
        width: '100%',
        ...(mode === 'widget' && {
          height: 352,
        }),
      }}
    >
      {children}
    </div>
  );
};
